import { InfoLayout } from "../../components/InfoLayout";

export function PrivacyPage() {
  return (
    <InfoLayout
      title="Privacy"
      lead="A plain-language summary of what PyDialog stores and how learner answers are handled. This is an honest description of the current system, not a legal contract."
    >
      <div className="card">
        <h3>What we store</h3>
        <p>
          For each account we keep a name, an email address, and learning progress
          — lesson attempts, scores, per-objective mastery, and a record of your
          dialogue sessions. This is held in the platform's own database on the
          server that runs it.
        </p>
      </div>

      <div className="card">
        <h3>How answers are graded</h3>
        <p>
          To assess understanding, the text of a learner's answer, the question,
          and the learning objective are sent to an external AI marker, which
          returns a grade and feedback. Nothing identifying the learner goes
          with it — no name, username, email or student number. Answers are used
          for marking only.
        </p>
        <p>
          A learner who declines AI marking, or who has not been asked yet, has
          nothing sent at all: their work is assessed on this server by an
          offline method instead. The same happens if no AI marker is
          configured.
        </p>
      </div>

      <div className="card">
        <h3>What we don't do</h3>
        <p>
          We don't sell personal data or use it for advertising. Instructors can
          see only the learners in their own cohort; learners can't see each
          other's results.
        </p>
      </div>

      <div className="card">
        <h3>Your data</h3>
        <p>
          You can request a copy or deletion of your account data at any time via
          the contact channel below. Because a deployment is run by the school or
          educator hosting it, they are the point of contact for data requests.
        </p>
      </div>
    </InfoLayout>
  );
}
